<div class="popup-container">
  <div class="content">
    @if (showCloseButton) {
      <div class="close-button">
        <i class="fas fa-times" (click)="close()"></i>
      </div>
    }
    @if (showTitle) {
      <div class="title">
        {{ dialogTitle | translate }}
      </div>
    }
    @if (dialogSubtitle) {
      <div class="subtitle">
        {{ dialogSubtitle | translate }}
      </div>
    }
    @if (showSeparator) {
      <div class="separator"></div>
    }
    <div
      class="section-text"
      [ngClass]="{ 'section-text--left': isTextAlignedLeft }"
    >
      {{ dialogText | translate }}
    </div>
    <div class="button-container">
      @if (showCancelButton) {
        <div class="button cancel-button">
          <div class="login-or-register__button" (click)="close()">
            {{ dialogCancelButton | translate }}
          </div>
        </div>
      }
      <div class="button confirm-button">
        <div class="login-or-register__button" (click)="confirm()">
          {{ dialogConfirmButton | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
